export default __webpack_public_path__ + "static/media/thevilenativity.5714c5ba.jpg";